import { ImageIcon } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Visible bordered placeholder box for images that haven't been supplied yet.
 * Renders the id and intended dimensions so real assets can be matched later.
 */
export function Placeholder({
  id,
  width,
  height,
  className,
  variant = "light", // 'light' | 'dark'
  aspect,
  label,
}) {
  const isDark = variant === "dark";
  const style = aspect
    ? { aspectRatio: aspect }
    : { aspectRatio: width && height ? `${width} / ${height}` : "16 / 9" };

  return (
    <div
      data-testid={`placeholder-${id}`}
      style={style}
      className={cn(
        "relative w-full overflow-hidden rounded-lg border-2 border-dashed flex items-center justify-center",
        isDark
          ? "border-white/30 bg-white/5 text-white/80"
          : "border-wafa-deep/25 bg-wafa-cream/40 text-wafa-deep placeholder-box",
        className,
      )}
    >
      <div className="flex flex-col items-center gap-2 px-4 text-center">
        <div
          className={cn(
            "flex h-10 w-10 items-center justify-center rounded-full",
            isDark ? "bg-white/10" : "bg-white",
          )}
        >
          <ImageIcon className={cn("h-5 w-5", isDark ? "text-white" : "text-wafa-deep")} />
        </div>
        <div className="font-mono text-xs sm:text-sm font-medium">{id}</div>
        {width && height ? (
          <div className={cn("font-mono text-[10px] sm:text-xs", isDark ? "text-white/60" : "text-wafa-deep/60")}>
            {width} × {height}
          </div>
        ) : null}
        {label ? (
          <div className={cn("mt-1 text-[10px] sm:text-xs", isDark ? "text-white/70" : "text-wafa-deep/70")}>
            {label}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default Placeholder;
